"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Headphones = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "headphones" },
            react_1.default.createElement("path", { id: "Icon", d: "M21 17C21 17.5523 21.4477 18 22 18C22.5523 18 23 17.5523 23 17H21ZM1 17C1 17.5523 1.44772 18 2 18C2.55228 18 3 17.5523 3 17H1ZM21 13V17H23V13H21ZM3 17V13H1V17H3ZM12 4C16.9706 4 21 8.02944 21 13H23C23 6.92487 18.0751 2 12 2V4ZM12 2C5.92487 2 1 6.92487 1 13H3C3 8.02944 7.02944 4 12 4V2ZM9 15.5V18.5H11V15.5H9ZM6 18.5V15.5H4V18.5H6ZM7.5 20C6.67157 20 6 19.3284 6 18.5H4C4 20.433 5.567 22 7.5 22V20ZM9 18.5C9 19.3284 8.32843 20 7.5 20V22C9.433 22 11 20.433 11 18.5H9ZM7.5 14C8.32843 14 9 14.6716 9 15.5H11C11 13.567 9.433 12 7.5 12V14ZM7.5 12C5.567 12 4 13.567 4 15.5H6C6 14.6716 6.67157 14 7.5 14V12ZM18 15.5V18.5H20V15.5H18ZM15 18.5V15.5H13V18.5H15ZM16.5 20C15.6716 20 15 19.3284 15 18.5H13C13 20.433 14.567 22 16.5 22V20ZM18 18.5C18 19.3284 17.3284 20 16.5 20V22C18.433 22 20 20.433 20 18.5H18ZM16.5 14C17.3284 14 18 14.6716 18 15.5H20C20 13.567 18.433 12 16.5 12V14ZM16.5 12C14.567 12 13 13.567 13 15.5H15C15 14.6716 15.6716 14 16.5 14V12Z" }))));
};
exports.default = Headphones;
